import { atom } from "jotai";

export const romIdAtom = atom<string | null>(null);

export const participantIdAtom = atom<string | null>(null);

export const romPhaseAtom = atom<"pairing" | "streaming">("pairing");
